import { education } from "../data/education";
import { profile } from "../data/profile";
import { publication } from "../data/research";

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Person",
      "@id": `${profile.portfolioUrl}/#person`,
      name: profile.name,
      jobTitle: profile.title,
      email: `mailto:${profile.email}`,
      homeLocation: { "@type": "Place", name: profile.location },
      url: profile.portfolioUrl,
      sameAs: [profile.linkedin],
      alumniOf: [
        { "@type": "CollegeOrUniversity", name: "Middlesex University" },
        { "@type": "CollegeOrUniversity", name: "Technische Universität Darmstadt" },
      ],
    },
    {
      "@type": "WebSite",
      "@id": `${profile.portfolioUrl}/#website`,
      name: `${profile.name} — Portfolio`,
      url: profile.portfolioUrl,
      author: { "@id": `${profile.portfolioUrl}/#person` },
      inLanguage: "en",
    },
    ...education.filter((item) => item.badge === "First Class").map((item) => ({
      "@type": "EducationalOccupationalCredential",
      name: item.title,
      credentialCategory: "Degree",
      recognizedBy: { "@type": "CollegeOrUniversity", name: item.organization },
      description: item.description,
    })),
    {
      "@type": "ScholarlyArticle",
      name: publication.title,
      url: publication.href,
      author: { "@id": `${profile.portfolioUrl}/#person` },
      about: ["Autonomous navigation", "Robotics", "LiDAR"],
      description: publication.summary,
    },
  ],
};

export function StructuredData() {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />;
}
